/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientDto } from '../models/ClientDto';
import type { ClientResponseDto } from '../models/ClientResponseDto';
import type { ClientUpdateRequestDTO } from '../models/ClientUpdateRequestDTO';
import { request as __request } from '@openapi/request';

export class ClientService {

    /**
     * @returns ClientResponseDto Retrieve a list of clients
     * @throws ApiError
     */
    public static async retrieveClientList(): Promise<Array<ClientResponseDto>> {
        const result = await __request({
            method: 'POST',
            path: `/live/api/v2/client/list`,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static async createNewClient(
        requestBody: ClientDto,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/live/api/client/create_new_client`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param clientOid
     * @returns ClientResponseDto
     * @throws ApiError
     */
    public static async retrieveClientWithOid(
        clientOid: string,
    ): Promise<ClientResponseDto> {
        const result = await __request({
            method: 'GET',
            path: `/live/api/v2/client/info/${clientOid}`,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns ClientResponseDto
     * @throws ApiError
     */
    public static async updateClientData(
        requestBody: ClientUpdateRequestDTO,
    ): Promise<ClientResponseDto> {
        const result = await __request({
            method: 'POST',
            path: `/live/api/v2/client/update`,
            body: requestBody,
        });
        return result.body;
    }

}